// extracted by mini-css-extract-plugin
export default {"order-fail":"OrderFail_order-fail__vO9fC"};